import { Injectable } from '@angular/core';
import { IApiResponse } from '@core/interfaces/api-response.interface';
import { UserInvitationService } from '@core/services/user-invitation.service';
import { ComponentStore } from '@ngrx/component-store';
import { IUserInvitation } from '@shared/interfaces/user-invitation.interface';
import { EMPTY, Observable } from 'rxjs';
import { catchError, switchMap, tap } from 'rxjs/operators';

interface ICampaignDetailsCreatorsState {
  invitations: IUserInvitation[];
  invitationsLoading: boolean;
  invitationsError: string | null;
}

const initialState: ICampaignDetailsCreatorsState = {
  invitations: [],
  invitationsError: null,
  invitationsLoading: false,
};

@Injectable()
export class CampaignDetailsCreatorsStore extends ComponentStore<ICampaignDetailsCreatorsState> {
  public readonly invitations = this.selectSignal((state) => state.invitations);
  public readonly invitationsLoading = this.selectSignal((state) => state.invitationsLoading);
  public readonly invitationsError = this.selectSignal((state) => state.invitationsError);

  public readonly fetchInvitations = this.effect((trigger$: Observable<void>) => {
    return trigger$.pipe(
      tap(() => this.patchState({ invitationsError: null, invitationsLoading: true })),
      switchMap(() =>
        this.userInvitationService.getCreatorInvitations().pipe(
          tap((response: IApiResponse<IUserInvitation[]>) => {
            this.patchState({ invitations: response.data ?? [], invitationsLoading: false });
          }),
          catchError(() => {
            this.patchState({ invitationsError: 'Failed to load invitations', invitationsLoading: false });

            return EMPTY;
          }),
        ),
      ),
    );
  });

  constructor(private readonly userInvitationService: UserInvitationService) {
    super(initialState);
  }
}
